import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiGroupItemComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoGroupingComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
    DxoSummaryComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../common/grid-page.component';
import {MB51QuantityGridViewDto, MB51Reason} from '@services';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import {DATE_TIME_FORMAT} from "../../../../shared/constants";

@Component({
    selector: 'app-mb51-quantities',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoSummaryComponent,
        DxoGroupingComponent,
        DxoLoadPanelComponent,
        DxoPositionComponent,
        DxoSortingComponent,
        DxoSearchComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxiColumnComponent,
        DxiGroupItemComponent,
        DxTemplateDirective,
        FilterPanelComponent,
        DxFormComponent,
        RouterLink,
    ],
    templateUrl: './mb51-quantities.component.html',
})
export class MB51QuantitiesComponent extends GridPageComponent<MB51QuantityGridViewDto> implements OnChanges {
    @Input() reason: MB51Reason = MB51Reason.Damage;

    protected override exportName: string = 'MB51 Quantities';
    protected offset: number = 150;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource: AspNetData.CustomStore | [] = [];

    protected override filterConfig: FilterConfig[] = [
        { field: 'date', op: '>=' },
        { field: 'documentHeaderText', op: 'contains' },
        { field: 'amountInLc', op: '>=' },
        { field: 'quantity', op: '>=' },
        { field: 'quantityCs', op: '>=' },
        { field: 'quantityPal', op: '>=' },
        { field: 'quantityDsp', op: '>=' },
        { field: 'quantityEa', op: '>=' },
    ];

    constructor() {
        super();
        this.init(MB51QuantityGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['reason']) {
            this.dataSource = this.dataSources.mb51Quantities(this.reason);
        }
    }
}
